<template>
    <div>
        <router-link
            id="navLogo"
            to="/"
            :style="{
              position,
              opacity,
              transform,
              top,
              left
            }"
        >
            <span class="small">small</span>Sky
        </router-link>
        <!-- :style="{position: position}" -->
    </div>
</template>

<script>
import pageLoadAnimationBus from '../pageLoadAnimationBus'
export default {
  props: {
    position: {
      type: String,
      default: 'absolute'
    },
    topProp: {
      type: Number,
      default: 20
    },
    leftProp: {
      type: Number,
      default: 30
    }
  },
  data () {
    return {
      opacity: 1,
      translateY: 0
    }
  },
  computed: {
    transform () { return 'translateY(' + (this.translateY).toString() + 'px)' },
    top () { return this.topProp + 'px' },
    left () { return this.leftProp + 'px' }
  },
  mounted () {
    pageLoadAnimationBus.registerComponent('logo', this)
  }
}
</script>

<style lang="scss" scoped>
#navLogo {
  display: flex;
  position: absolute;
  z-index: 100000;
  letter-spacing: -0.035em;
  font-family: Poppins;
  font-style: normal;
  font-size: 40px;
  //line-height: 66px;
  text-align: center;
  font-weight: bold;
  color: white;
  text-decoration: none;
}
</style>
